import { createContext, useContext } from 'react';

const LeagueContext = createContext(null);

export function LeagueProvider({ leagueId, season, shareToken = null, children }) {
  return (
    <LeagueContext.Provider value={{ leagueId, season, shareToken }}>
      {children}
    </LeagueContext.Provider>
  );
}

export function useLeague() {
  const context = useContext(LeagueContext);
  if (!context) {
    throw new Error('useLeague must be used within a LeagueProvider');
  }
  return context;
}

/** The league context, or null on a page with no LeagueProvider (Home). */
export function useLeagueOptional() {
  return useContext(LeagueContext);
}
